import Vue from 'vue'
import Vuex from 'vuex'
import seo from './modules/seo'
import getters from './getters'
Vue.use(Vuex)

// const store = new Vuex.Store({
//   modules: {
//     app
//   },
// })
const store = new Vuex.Store({
    state: {
        cancelTokenArr: [] // 取消请求token数组
      },
      mutations: {
        pushToken (state, payload) {
          state.cancelTokenArr.push(payload.cancelToken)
        },
        clearToken ({ cancelTokenArr }) {
          cancelTokenArr.forEach(item => {
            item('路由跳转取消请求')
          })
          cancelTokenArr = []
        }
      },
      modules:{
        seo
      },
      getters
  })

export default store



// WEBPACK FOOTER //
// ./src/store/index.js